import { useMutation } from "@tanstack/react-query";

import {
  FeedbackImageResponse,
  FeedbackRequest,
  FeedbackResponse,
  postFeedback,
  uploadFeedbackImage
} from "./feedbackFunctions";

export const usePostFeedback = () => {
  return useMutation<
    FeedbackResponse,
    Error,
    { data: FeedbackRequest; isAuthenticated: boolean }
  >({
    mutationFn: ({ data, isAuthenticated }) =>
      postFeedback(data, isAuthenticated)
  });
};

export const useUploadFeedbackImage = () => {
  return useMutation<
    FeedbackImageResponse,
    Error,
    { caseId: string; file: File; isAuthenticated: boolean }
  >({
    mutationFn: ({ caseId, file, isAuthenticated }) =>
      uploadFeedbackImage(caseId, file, isAuthenticated)
  });
};
